import React from 'react'
import { Decimal } from 'decimal.js';

function calculateTotalNumber(orders) {
    let total = 0

    orders.forEach(order => total += parseInt(order.number, 10))

    return total
}

function calculateTotalm2(glassOrders) {
    let total = new Decimal(0)

    glassOrders.forEach(order =>
        total = total.add(new Decimal(order.height * order.width * order.number / 1000000))
    )

    return total.toFixed(2)
}

const OrderOverviewTable = ({glassOrders, windowOrders, ventilationOrders}) => {

    return (
        <table className="table mb-5 overview-table">
            <tbody>
                <tr>
                    <th>Totaal m<sup>2</sup> ruiten</th>
                    <td>{ calculateTotalm2(glassOrders) }</td>
                </tr>
                <tr>
                    <th>Aantal ruiten</th>
                    <td>{ calculateTotalNumber(glassOrders) }</td>
                </tr>
                <tr>
                    <th>Aantal roosters</th>
                    <td>{ calculateTotalNumber(ventilationOrders) }</td>
                </tr>
                <tr>
                    <th>Aantal draairamen</th>
                    <td>{ calculateTotalNumber(windowOrders) }</td>
                </tr>
            </tbody>
        </table>
    )
}

export default OrderOverviewTable;


// WEBPACK FOOTER //
// ./src/components/OrderOverviewTable.js